var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lucide:scan-eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.75 22.75V16.25C9.75 14.5261 10.4348 12.8728 11.6538 11.6538C12.8728 10.4348 14.5261 9.75 16.25 9.75H22.75M55.25 9.75H61.75C63.4739 9.75 65.1272 10.4348 66.3462 11.6538C67.5652 12.8728 68.25 14.5261 68.25 16.25V22.75M68.25 55.25V61.75C68.25 63.4739 67.5652 65.1272 66.3462 66.3462C65.1272 67.5652 63.4739 68.25 61.75 68.25H55.25M22.75 68.25H16.25C14.5261 68.25 12.8728 67.5652 11.6538 66.3462C10.4348 65.1272 9.75 63.4739 9.75 61.75V55.25",
    stroke: "#ED5272",
    strokeWidth: 6.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39 42.25C40.7949 42.25 42.25 40.7949 42.25 39C42.25 37.2051 40.7949 35.75 39 35.75C37.2051 35.75 35.75 37.2051 35.75 39C35.75 40.7949 37.2051 42.25 39 42.25Z",
    stroke: "#ED5272",
    strokeWidth: 6.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.25 39C16.25 39 24.375 22.75 39 22.75C53.625 22.75 61.75 39 61.75 39C61.75 39 53.625 55.25 39 55.25C24.375 55.25 16.25 39 16.25 39Z",
    stroke: "white",
    strokeWidth: 6.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.7f6fe2268badc53d86c4ee516d737909.svg";
export { ForwardRef as ReactComponent };